import { __assign, __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import * as React from 'react';
import { Lock } from '../../icons/icons/Lock';
import { inputReadOnly } from '../../shared/styles';
export var ReadOnlyLock = styled(function (props) { return React.createElement(Lock, __assign({}, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), inputReadOnly);
var templateObject_1;
//# sourceMappingURL=ReadOnlyLock.js.map